import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { logException } from '../sentry';
export class BaseClient {
  constructor(config) {
    _defineProperty(this, "logException", (ex, name, context) => {
      logException(ex, name, context);
      this.config.logException(ex, name, context);
    });
    this.config = config;
    this.context = {
      cloudId: 'None'
    };
  }
  setContext(context) {
    this.context = {
      ...context,
      cloudId: context.cloudId || 'None'
    };
  }
  getContext() {
    return this.context;
  }

  /**
   *
   * @param localValue is used for backwards compatibility
   * @returns
   */
  getOrgId(localValue) {
    const orgId = localValue || this.getContext().orgId;
    if (!orgId) {
      const err = new Error('No orgId set');
      this.logException(err, 'No orgId set');
      throw err;
    }
    return orgId;
  }
  /**
   *
   * @param localValue is used for backwards compatibility
   * @returns
   */
  getCloudId(localValue) {
    return localValue || this.getContext().cloudId;
  }
}